import { loginError } from './../login.mock';
import { ENVIRONMENT } from 'src/environments/environment';
import { login } from '../login.mock';
import { mfListMock } from '../mf-list.mock';


const mockUserDataStorage = JSON.parse(localStorage.getItem('lealUserData') as string)
export const endpoints = [
  {
    method: 'POST',
    path: `${ENVIRONMENT.urls.api}/auth/login`,
    response: login,
    enabled: false,
    status: 200,
  },
  {
    method: 'POST',
    path: `${ENVIRONMENT.urls.api}/auth/login`,
    response: loginError,
    enabled: false,
    status: 500,
  },
  {
    method: 'POST',
    path: `${ENVIRONMENT.urls.api}/auth/login`,
    response: loginError,
    enabled: false,
    status: 400,
  },
  {
    method: 'GET',
    path: `${ENVIRONMENT.urls.api}/module/config/commerce/${
      mockUserDataStorage?.idCommerce.toString() || '3'
    }?id_role=${mockUserDataStorage?.idRole.toString() || '2'}`,
    response: mfListMock,
    enabled: true,
    status: 200,
  },
];
